export default __webpack_public_path__ + "static/media/inactive.3bc7d094.svg";